import { useTranslation } from 'react-i18next';

import type { ReactNode } from '@tanstack/react-router';
import { FileDownIcon, PlusIcon, Share2Icon, Trash2Icon } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { DropdownMediaButtons } from './dropdown-media-buttons';

type EstateMediaButtonsProps = {
  type: 'estate';
  estateId: string;
};

type ProjectMediaButtonsProps = {
  type: 'project';
  projectId: string;
};

export type MediaButtonsProps = {
  tabButton?: ReactNode;
  isThumbnailDisabled?: boolean;
  onSelect?: () => void;
  onDelete?: () => void;
  onShare?: () => void;
  onDownload?: () => void;
  onUpload?: () => void;
  onChooseThumbnail?: () => void;
  onClickImageRendering?: () => void;
} & (EstateMediaButtonsProps | ProjectMediaButtonsProps);

export const MediaButtons = ({
  type = 'estate',
  tabButton,
  isThumbnailDisabled,
  onSelect,
  onDelete,
  onShare,
  onDownload,
  onUpload,
  onChooseThumbnail,
  onClickImageRendering,
}: MediaButtonsProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex space-x-1 sm:space-x-2">
      <Button onClick={onUpload} variant="outline" className="border-[3px] !px-1" rounded>
        <PlusIcon className="h-5 w-5" strokeWidth={3} />
      </Button>
      {tabButton}
      <Button
        variant="outline"
        className="hidden !px-2 text-xs sm:text-sm md:block"
        disabled={isThumbnailDisabled}
        onClick={onChooseThumbnail}
      >
        {t('chose-thumbnail')}
      </Button>
      <Button className="!px-2 text-xs sm:text-sm" onClick={onSelect} variant="outline">
        {t('select')}
      </Button>
      {type === 'estate' ? (
        <Button
          className="!px-2 text-xs sm:text-sm"
          onClick={onClickImageRendering}
          variant="outline"
        >
          {t('aiImageRendering')}
        </Button>
      ) : null}
      <div className="hidden xl:flex xl:space-x-2">
        <Button onClick={onDelete} variant="outline">
          <Trash2Icon />
        </Button>
        {type === 'estate' ? (
          <Button onClick={onShare} variant="outline">
            <Share2Icon />
          </Button>
        ) : null}
        <Button className="!px-2" onClick={onDownload}>
          <FileDownIcon />
          {t('download')}
        </Button>
      </div>
      <DropdownMediaButtons
        type={type}
        onChooseThumbnail={onChooseThumbnail}
        onDelete={onDelete}
        onDownload={onDownload}
        onShare={onShare}
      />
    </div>
  );
};
